import { ref } from "vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { store } from "../store/PasswordChangeStore";
const log = Log.create("Password.load");
export const useLoad = () => {
    const loading = ref(false);
    const loadChangeHtml = async (props = null) => {
        try {
            loading.value = true;
            await store.loadChangeHtml();
        }
        catch (ex) {
            log.error("loadChangeHtml", ex);
            MsgBox.error(ex.message);
        }
        finally {
            loading.value = false;
        }
    };
    const loadCompleteHtml = async (props = null) => {
        try {
            loading.value = true;
            await store.loadCompleteHtml();
        }
        catch (ex) {
            log.error("loadCompleteHtml", ex);
            MsgBox.error(ex.message);
        }
        finally {
            loading.value = false;
        }
    };
    return {
        loading,
        loadChangeHtml,
        loadCompleteHtml
    };
};
